import { useState } from 'react';
import './App.css';
import PersonUpload from './components/PersonUpload';
import ProductUpload from './components/ProductUpload';
import OutputDisplay from './components/OutputDisplay';

function App() {
  const [personImage, setPersonImage] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [outputImage, setOutputImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleGenerateTryOn = async () => {
    if (!personImage || productImages.length === 0) {
      alert('Please upload both person and product images');
      return;
    }

    setIsGenerating(true);
    setProgress(0);
    setOutputImage(null);

    // Simulate progress for UX (actual API doesn't stream progress)
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 15;
      });
    }, 500);

    try {
      const formData = new FormData();
      formData.append('person_image', personImage);
      formData.append('product_image', productImages[0]);
      formData.append('jewelry_type', 'necklace');

      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${apiUrl}/api/try-on`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const errorMsg = errorData?.error || 'Failed to generate try-on';
        throw new Error(errorMsg);
      }

      setProgress(100);
      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      setOutputImage(imageUrl);
    } catch (error) {
      console.error('Error generating try-on:', error);
      alert(error.message || 'Failed to generate try-on. Please try again.');
    } finally {
      clearInterval(progressInterval);
      setIsGenerating(false);
    }
  };

  return (
    <div className="App">
      <header className="header">
        <div className="logo-container">
          <span className="logo-icon">💎</span>
          <h1 className="logo">layr.fit</h1>
        </div>
        <p className="tagline">AI-Powered Virtual Try-On</p>
      </header>

      <main className="container">
        <div className="card">
          <PersonUpload
            personImage={personImage}
            setPersonImage={setPersonImage}
          />
        </div>

        <div className="card">
          <ProductUpload
            productImages={productImages}
            setProductImages={setProductImages}
          />
        </div>

        <div className="card output-card">
          <OutputDisplay
            outputImage={outputImage}
            isGenerating={isGenerating}
            onGenerate={handleGenerateTryOn}
            progress={progress}
          />
        </div>
      </main>

      <footer className="footer">
        <p>Powered by Gemini 2.5 Flash Image • AI-Powered Virtual Try-On</p>
      </footer>
    </div>
  );
}

export default App;
